import { useEffect } from "react";
import "./tailwind.css";

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
    useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const script = document.createElement('script');
      script.src = 'http://localhost:8097';
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      {children}
    </>
  );
}
